<template>
    <div>
        <!-- 🔼 Header -->
        <div class="slide mb-5" style="margin-top: 74px !important;">
            <div class="bg-img">
                <div class="slide-content">
                    <div>
                        <h2 class="slide-header">{{ 'Downgrade' }}</h2>
                    </div>
                    <div>
                        <h5 class="slide-h5">{{ $t('message.home') }}</h5>
                        <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider" />
                        <h5 class="slide-h5">{{ 'Downgrade' }}</h5>
                        <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider" />
                        <h5 class="slide-h5">{{ 'Downgrade-details' }}</h5>

                    </div>
                </div>
            </div>
        </div>
        <div class="container mt-4">


            <!-- 🔽 حالة الـ Scrap -->
            <b-alert class="text-center mx-auto" :variant="statusVariant" show
                style="max-width: 350px; font-size: 1.1rem;">
                <b-icon icon="info-circle-fill" class="mr-1" />
                {{ statusLabel }}
            </b-alert>

            <!-- 🟨 الأزرار تظهر فقط إذا الحالة waiting admin (code = 1) -->
            <div v-if="scrapStatus == 1" class="text-center mt-3">
                <!-- Textarea -->
                <b-form-textarea v-model="comments" placeholder="أدخل تعليق..." rows="3" max-rows="5"
                    class="mb-3"></b-form-textarea>

                <!-- Accept button -->
                <b-button variant="success" class="mx-2" @click="updateScrapStatus(5)">
                    <b-icon icon="check-circle" class="mr-1" />
                    Accept
                </b-button>

                <!-- Refuse button -->
                <b-button variant="danger" class="mx-2" @click="updateScrapStatus(2)">
                    <b-icon icon="x-circle" class="mr-1" />
                    Refuse
                </b-button>
            </div>

            <div
                v-if="viewComment && typeof viewComment === 'string' && viewComment.trim() !== '' && viewComment.trim().toLowerCase() !== 'undefined'">
                <b-alert variant="info" show class="text-center mx-auto mt-3" style="max-width: 500px;">
                    <b-icon icon="chat-left-text" class="mr-2" />
                    comment: {{ viewComment }}
                </b-alert>
            </div>



            <!-- زر Completed يظهر فقط عند status === 7 -->
            <!-- <div v-if="scrapStatus === 7" class="text-center mb-3">
                <b-button variant="success" @click="markCompleted">
                    <b-icon icon="check-circle-fill" class="mr-1" />
                    Completed
                </b-button>
            </div> -->

            <h2 class="mb-4 text-primary">
                Downgrade Items for ID: {{ downgradeId }}
            </h2>


            <b-table responsive striped bordered hover class="invoice-table mt-4 custom-body" :items="downgradeItems"
                :fields="fields" :per-page="perPage" :current-page="currentPage" :busy="isLoading">
                <template #table-busy>
                    <div class="text-center my-4">
                        <b-spinner label="Loading..." variant="primary" />
                    </div>
                </template>

                
                <template #cell(expiry)="data">
                    <span class="font-weight-bold" :class="data.item.expiry === 'yes' ? 'text-success' : 'text-danger'">
                        {{ data.item.expiry === 'yes' ? 'نعم' : 'لا' }}
                    </span>
                </template>


                <template #cell(attachment_security)="data">
                    <a :href="data.item.attachment_security" target="_blank" v-if="data.item.attachment_security">
                        View Attachment
                    </a>
                    <span v-else>-</span>
                </template>

                <!-- 👇 Pagination section -->
                <template #table-caption>
                    <div class="d-flex align-items-center justify-content-between px-2">
                        <div class="d-flex align-items-center">
                            <label class="mr-2 font-weight-bold">Rows per page:</label>
                            <b-form-select :options="perPageOptions" v-model="perPage" @change="onPerPageChange"
                                size="sm" style="width: 100px;" />
                        </div>

                        <b-pagination pills size="sm" class="mb-0" :total-rows="totalRows" v-model="currentPage"
                            :per-page="perPage" @change="changePage" />
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>

import axiosInstance from '../axios-config';

export default {
    data() {
        return {
            downgradeId: this.$route.params.downgrade_id,
            // ⬇️ تفاصيل الـ scrap
            scrapStatus: null,     // 0–8
            // جدول
            downgradeItems: [],
            currentPage: 1,
            perPage: 10,
            perPageOptions: [5, 10, 20, 50, 100],
            totalRows: 0,
            isLoading: false,
            fields: [
                { key: 'desc_ar', label: 'اسم الصنف' },
                { key: 'model_number', label: 'الموديل' },
                { key: 'quantity', label: 'الكمية الاجمالية للصنف' },
                { key: 'quantityScrap', label: 'Downgrade quantity' },
                { key: 'uom', label: 'الوحدة' },
                { key: 'manufacture', label: 'بلد المنشأ' },
                { key: 'expiry', label: 'قابلية الانتهاء' },
                { key: 'attachment_security', label: 'مرفق الأمان' }
            ],
            comments: '',
            viewComment: null,
        };
    },

    computed: {
        /* نص الحالة */
        statusLabel() {
            const map = {
                0: 'New',
                1: 'Waiting Admin',
                2: 'Cancelled by Admin',
                3: 'Waiting Finance',
                4: 'Cancelled by Finance',
                5: 'Waiting Company',
                6: 'Cancelled by Company',
                7: 'Requester Closed',
                8: 'Completed'
            };
            return map[this.scrapStatus] || 'Unknown';
        },
        /* لون الـ Badge */
        statusVariant() {
            const map = {
                0: 'warning',
                1: 'info',
                2: 'danger',
                3: 'info',
                4: 'danger',
                5: 'info',
                6: 'danger',
                7: 'secondary',
                8: 'success'
            };
            return map[this.scrapStatus] || 'secondary';
        }
    },

    mounted() {
        this.fetchScrapDetails();   // ⬅️ جديد
        this.fetchdowngradeItems();
    },

    methods: {
        /* ❶ جلب بيانات الـ Scrap (status) */
        async fetchScrapDetails() {
            try {
                const res = await axiosInstance.get(`store/select_downgrade_by_id.php?downgrade_id=${this.downgradeId}`);
                if (res.data.status === 'true') {
                    this.scrapStatus = parseInt(res.data.output.status);
                    if (res.data.output.comments === undefined || res.data.output.comments === null) {
                        this.viewComment = '';
                    } else {
                        this.viewComment = String(res.data.output.comments);
                    }

                } else {
                    this.$izitoast.warning({ title: 'Warning', message: res.data.message });
                }
            } catch (err) {
                console.error('Failed to fetch scrap details', err);
            }
        },

        /* ❷ جلب الأصناف (كما كانت) */
        async fetchdowngradeItems() {
            this.isLoading = true;
            const fd = new FormData();
            fd.append('page', this.currentPage);
            fd.append('page_size', this.perPage);

            try {
                const res = await axiosInstance.post(
                    `store/select_downgrade_items.php?downgrade_id=${this.downgradeId}`,
                    fd
                );

                if (res.data.status === 'true') {
                    this.downgradeItems = res.data.output;
                    this.totalRows = parseInt(res.data.pagination.total_products || this.downgradeItems.length);
                } else {
                    this.$izitoast.warning({ title: 'Warning', message: res.data.message });
                }
            } catch (err) {
                console.error('Failed to fetch scrap items', err);
                this.$izitoast.error({ title: 'Error', message: 'Error fetching items' });
            } finally {
                this.isLoading = false;
            }
        },

        onPerPageChange() {
            this.currentPage = 1;
            this.fetchdowngradeItems();
        },

        changePage(val) {
            this.currentPage = val;
            this.fetchdowngradeItems();
        },

        /* ❸ زر Completed → status = 8 */
        // async markCompleted() {
        //     const fd = new FormData();
        //     fd.append('scrap_id', this.downgradeId);
        //     fd.append('status', 8); // Completed

        //     try {
        //         const res = await axiosInstance.post('store/update_scrap_status.php', fd);
        //         if (res.data.status === 'true') {
        //             this.scrapStatus = 8;
        //             this.$izitoast.success({
        //                 title: 'Success',
        //                 message: 'Scrap marked as Completed',
        //                 position: 'bottomLeft'
        //             });
        //         } else {
        //             throw new Error(res.data.message);
        //         }
        //     } catch (err) {
        //         console.error('Error updating status', err);
        //         this.$izitoast.error({ title: 'Error', message: 'Failed to update status', position: 'bottomLeft' });
        //     }
        // },
        async updateScrapStatus(statusCode) {
            if (statusCode === 2 && !this.comments.trim()) {
                this.$izitoast.warning({
                    title: 'تعليق مطلوب',
                    message: 'يرجى كتابة سبب الرفض.',
                    position: 'bottomLeft',
                });
                return;
            }
            try {
                const formData = new FormData();
                formData.append('downgrade_id', this.downgradeId);  // أو حسب المتغير عندك
                formData.append('status', statusCode);
                formData.append('comments', this.comments);


                const res = await axiosInstance.post('store/update_downgrade_status.php', formData);

                if (res.data.status === 'true') {
                    this.$izitoast.success({
                        title: 'Success',
                        message: 'Downgrade status updated successfully.',
                        position: 'bottomLeft'
                    });
                    console.log('typeOf',typeof(statusCode));
                    
                    // تحديث الحالة المعروضة
                    this.scrapStatus = String(statusCode);
                } else {
                    throw new Error(res.data.message || 'Update failed.');
                }
            } catch (err) {
                console.error('Error updating status:', err);
                this.$izitoast.error({
                    title: 'Error',
                    message: 'Failed to update scrap status.',
                    position: 'bottomLeft'
                });
            }
        }
    }
};
</script>

<style scoped>
.invoice-table {
    font-size: 14px;
}

.invoice-table {
    font-size: 14px;
}

.perPageSelect {
    border-radius: 6px;
    padding: 4px 10px;
}
</style>
